<div class="grid-container">
	<h3>{{ greatMessage }}</h3>
	<div>
		<button class="btn btn-primary btn-margin" (click)="auth.login()" *ngIf="!auth.authenticated">Log In</button>
		<button class="btn btn-primary btn-margin" (click)="auth.logout()" *ngIf="auth.authenticated">Log Out</button>
	</div>
</div>